 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import { isEmpty, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, isEnabled, isNumber } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';


const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const WorkProgMgr = props => {

    const panelsdef = [];
    const formid = getformid("WorkProgMgr", props.location.search);
    const controller = getcontroller("WorkProgMgr", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const menuinfo = useSelector(state => state.form.menuinfo);

    const fnc = useRef();
    const baseref = useRef();

    //データ
    const entrydataRef = useRef(null);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const ComFunc = React.forwardRef(ComFunction);

    const [pendingOrderLaunches, setPendingOrderLaunches] = useState([]);

    const actionurl = {
        "getlist": "WorkProgMgr/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "callform1", icon: "output", label: "納品明細入力" },
        { status: "VIEW", menuid: "callform2", icon: "output", label: "INVOICE入力" },
        { status: "VIEW", menuid: "callform3", icon: "output", label: "原材料出荷明細入力" },
    ]

    const linkfields = [
        { id: 'SSH_HACHUNO', controller: 'ShnOrder', value:'SSH_HACHUNO'},
        { id: 'SSH_SSDNO', controller: 'Kakousiji?type=D_SSD2', value: 'SSH_SSDNO' },
        { id: 'SSH_HINBAN', controller: 'HinbanMaster?type=HinbanMaster', value: 'SSH_OPPICD' },
        { id: 'SSH_NOUKIANSYMD1', controller: 'Kakousiji?type=D_SSD2', value: 'SSH_SSDNO' },
        { id: 'SSH_NMDDENYMD', controller: 'DeliveryDtl', controller2: 'OverseasDel', value: 'NMM_DENNO' },             //納品明細
        { id: 'SSH_SIIRENYUDENYMD', controller: 'PurchaseRcpt', value: 'SSH_SIIRENYUDENYMD' },        //仕入入荷
        { id: 'SSS_ZAIDENNO', controller: 'RawM?type=D_KHD', value: 'SSS_ZAIDENNO', addstate: { historyType: 0 } },     //原材料発注（素材）
        { id: 'SSS_ZAIDENNO2', controller: 'RawM?type=D_KHD', value: 'SSS_ZAIDENNO2', addstate: { historyType: 1 } },   //原材料発注（附属・副資材）
        { id: 'SSS_SSDNO', controller: 'Kakousiji?type=D_SSD2', value: 'SSS_SSDNO' },
        { id: 'SSS_SDDDENYMD', controller: 'RawPurchase', value: 'SSS_SDDDENNO' },  //原材料仕入
        { id: 'SSH_INVOICEYMD', controller: 'InvoiceIn', value: 'SSH_INVOICEYMD' },  //Invoice
    ]

    //動作抑止
    const suppressaction = [
        { type: "0", action: "INSERT" },
        { type: "0", action: "UPDATE" },
    ];

    function linkaction(p) {
        if (!linkfields.some(e => e.id === p.column.colId)) return;
        if (p.event.ctrlKey || p.event.metaKey) {     //Ctrl+Click
            var target = linkfields.find(e => e.id === p.column.colId);
            if (target.controller === '' || target.value === '') return;
            if (isEmpty(p.data[target.value]) || isEmpty(p.data[target.id])) return;
            let code = p.data[target.value];
            let state = "ENTRY";
            if (target.id === "SSH_NMDDENYMD") {    //納品明細日付
                if (p.data["NMD_KAIGAIKBN"] === '1') {  //国内→納品明細入力
                    code = p.data["SSH_HACHUNO"] + "," + p.data["SSH_HACHUKEITAI"] + "," + p.data["SSH_SSDNO"];
                    formcall('', target.controller, "LIST", { keys: code });
                }
                if (p.data["NMD_KAIGAIKBN"] === '2') {  //海外→海外納品明細
                    code = p.data["SSH_HACHUNO"] + "," + p.data["SSH_HACHUKEITAI"] + "," + p.data["SSH_SSDNO"];
                    formcall('', target.controller2, "LIST", { keys: code });
                }
                return;
            }
            if (target.id === "SSS_ZAIDENNO2") {    //附属・副資材発注番号
                target.addstate.historyType = NumConv(p.data["FRH_DENKIND"]) + 1;
            }
            if (target.id === "SSH_SIIRENYUDENYMD") {   //仕入入荷LIST
                code = p.data["SSH_HACHUNO"] + "," + p.data["SSH_HACHUKEITAI"] + "," + p.data["SSH_SSDNO"];
                formcall('', target.controller, 'LIST', {keys:code});   
                return;
            }
            if (target.id === "SSH_INVOICEYMD") {       //InvoiceLIST
                code = p.data["SSH_HACHUNO"] + "," + p.data["SSH_HACHUKEITAI"] + "," + p.data["SSH_SSDNO"];
                formcall('', target.controller, 'LIST', { keys: code });
                return;
            }
            formcall(code, target.controller, state, target.addstate);
        }
        function formcall(code, controller, status, addstate) {
            const state = {
                status: status,
                code: code,
                accepttype: formid,
                ...addstate
            };
            fnc.current.callform(state, controller);
        }
    }

    function MenuAction(action, finallycallback, param) {
        if (action === 'callform1') {   //納品明細入力
            let data = baseref.current?.GetSelectrowdata();
            if (data.length === 0) {
                fnc.current.warnmsg("対象データを選択してください");
                return;
            }
            if (data.length > 1) {
                fnc.current.warnmsg("発注番号が複数選択されました、1つを選択してください。");
                return;
            }
            if (!DeliveryDtlCheck(data[0])) return;
            var delvs = shopslist(data[0], "DELVLIST");
            //店舗分１＋店舗以外の納品先分を作成 ※店舗の場合コード='*'
            if (delvs.length === 0 || (delvs.length === 1 && shopslist(data[0]).length == 1)) { //店舗以外が1件　又はすべて店舗
                var state = newformstatus(data[0], delvs.length===1?delvs[0]:'*');
                fnc.current.callform(state, 'DeliveryDtl');
            } else {
                var shops = shopslist(data[0]);
                if (shops.length !== delvs.length) {
                    delvs.push('*');        //店舗配分あり
                }
                callforms(delvs, data[0], 'DeliveryDtl')
            }
        }
        if (action === 'callform2') {   //INVOICE
            let data = baseref.current?.GetSelectrowdata();
            if (data.length === 0) {
                fnc.current.warnmsg("対象データを選択してください");
                return;
            }
            if (data.length > 1) {
                fnc.current.warnmsg("発注番号が複数選択されました、1つを選択してください。");
                return;
            }
            if (!InvoiceCheck(data[0])) return;
            //納品先分INVOICEを作成
            if (shopslist(data[0]).length === 1) {
                var state = newformstatus(data[0], shopslist(data[0])[0]);
                fnc.current.callform(state, 'InvoiceIn');
            } else {
                callforms(shopslist(data[0]), data[0], 'InvoiceIn')
            }
        }
        if (action === 'callform3') {   //原材料出荷明細
            let param = baseref.current?.GetSelectrowdata();
            if (param.length === 0) {
                fnc.current.warnmsg("対象データを選択してください");
                return;
            }
            fnc.current.warnmsg("この機能は未実装です");
        }
    }
    function callforms(shops, data, controller) {
        const placeholderTabs = createPlaceholderTabs(shops.length);
        const requests = buildCallformRequests(controller, shops, data);
        if (requests.length === 0) {
            closePlaceholderTabs(placeholderTabs);
            setPendingOrderLaunches([]);
            return;
        }
        const targetTab = placeholderTabs.length !== 0 ? placeholderTabs[0] : null;
        const firstOpenedTab = fnc.current.callform(requests[0].state, requests[0].callid, targetTab);
        closePlaceholderTabs(placeholderTabs, 1);
        if (firstOpenedTab === null) {
            setPendingOrderLaunches(requests);
            fnc.current.warnmsg("ブラウザ制限のため自動で複数タブを開けません。起動一覧から 1 件ずつ開いてください。");
            return;
        }
        const remains = requests.slice(1);
        setPendingOrderLaunches(remains);
    }
    function pendingOrderLaunchLabel(item) {
        if (isEmpty(item)) return "";
        return "起動対象 " + (item.index + 1);
    }
    function openPendingOrderLaunch(item) {
        if (isEmpty(item)) return false;
        const openedTab = fnc.current.callform(item.state, item.callid);
        if (openedTab === null) {
            fnc.current.warnmsg("タブを開けませんでした。ブラウザのポップアップ設定を確認してください。");
            return false;
        }
        setPendingOrderLaunches((prev) => prev.filter((entry) => entry.index !== item.index));
        return true;
    }

    function buildCallformRequests(controller, shops, data) {
        return (Array.isArray(shops) ? shops : []).map((detail, index) => ({
            index: index,
            callid: controller,
            state: newformstatus(data, detail)
        }));
    }
    function preparePlaceholderTab(tab) {
        if (tab && !tab.closed) {
            try {
                tab.document.title = "起動中";
            } catch (error) {
            }
        }
    }
    function closePlaceholderTabs(tabs, startIndex = 0) {
        if (!Array.isArray(tabs)) return;
        for (let i = startIndex; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab && !tab.closed) {
                try {
                    tab.close();
                } catch (error) {
                }
            }
        }
    }

    function createPlaceholderTabs(count) {
        const tabs = [];
        if (count <= 0) return tabs;
        const firstTab = window.open("", "_blank");
        preparePlaceholderTab(firstTab);
        tabs.push(firstTab);
        for (let i = 1; i < count; i++) {
            let tab = null;
            try {
                // 環境によっては親タブから複数回 open するより、最初に開いたタブを起点にした方が
                // ユーザー操作由来として扱われやすい。
                tab = firstTab && !firstTab.closed ? firstTab.open("", "_blank") : window.open("", "_blank");
            } catch (error) {
                tab = null;
            }
            preparePlaceholderTab(tab);
            tabs.push(tab);
        }
        return tabs;
    }

    function newformstatus(data, shop) {
        var info = {
            "SSH_HACHUNO": data["SSH_HACHUNO"], "SSH_HACHUKEITAI": data["SSH_HACHUKEITAI"], "SSH_SSDNO": data["SSH_SSDNO"], "SHOP": shop
        }
        return {
            status: "NEW",
            code: '',
            acceptinfo: info,
            accepttype: formid,
        };
    }
    function shopslist(data, id) {
        if (isEmpty(id)) id = "TENPOLIST";
        if (isEmpty(data[id])) return [];
        return data[id].split(",");
    }
    function DeliveryDtlCheck(data) {
        if (data["TOR_KAIGAIKBN"] === "2") {
            fnc.current.warnmsg("海外区分が海外のため、納品明細を作成することはできません");
            return false;
        }
        if (isEmpty(data["TENPOLIST"])) {
            fnc.current.warnmsg(["事業部で実施する「製商品発注店舗配分」の確定が行われていないため", "納品明細を作成することが出来ません。事業部担当者へお問い合わせください。"]);
            return false;
        }
        return true;
    }
    function InvoiceCheck(data) {
        if (data["TOR_KAIGAIKBN"] === "1") {
            fnc.current.warnmsg("海外区分が国内のため、Invoiceを作成することはできません");
            return false;
        }
        if (data["SSD_CONTRACTNO"] === "") {
            fnc.current.warnmsg("ContractNoが未設定のため、Invoiceを作成することはできません");
            return false;
        }
        if (isEmpty(data["TENPOLIST"])) {
            fnc.current.warnmsg(["事業部で実施する「製商品発注店舗配分」の確定が行われていないため", "INVOICEを作成することが出来ません。事業部担当者へお問い合わせください。"]);
            return false;
        }
        return true;
    }
    function selectdata(data) {
        var targets = [];
        data.forEach(row => {
            targets.push({ SSH_HACHUNO: row["SSH_HACHUNO"], SSH_HACHUKEITAI: row["SSH_HACHUKEITAI"], SSH_SSDNO: row["SSH_SSDNO"] })
        });
        return targets;
    }

    function celstyle(p) {
        if (linkfields.some(e => e.id === p.column.colId)) {
            return { cursor: 'pointer', textDecoration: 'underline', textDecorationColor: '#3B82F6' };
        }
    }

    //ListOption Change
    function OptionChanged(id, value) {
        if (value === '0') {
            baseref.current.ChangeNavmenu(navmenu.filter(e => e.menuid !== "callform3"));
        } else {
            baseref.current.ChangeNavmenu(navmenu.filter(e => e.menuid !== "callform1" && e.menuid !== "callform2"));
        }
    }
    function renderPendingOrderLaunchDialog() {
        if (pendingOrderLaunches.length === 0) return null;
        const dialogStyle = {
            position: "fixed",
            inset: 0,
            zIndex: 4100,
            backgroundColor: "rgba(0,0,0,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16
        };
        const paperStyle = {
            width: "min(520px, 96vw)",
            maxHeight: "90vh",
            overflow: "auto",
            padding: 20
        };
        const footerStyle = { display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 };
        return (
            <div style={dialogStyle} onClick={() => setPendingOrderLaunches([])}>
                <Paper elevation={3} style={paperStyle} onClick={(e) => e.stopPropagation()}>
                    <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>残りの起動対象</div>
                    <div style={{ fontSize: 12, color: "#444", marginBottom: 12 }}>
                        ブラウザ制限のため、自動で複数タブを同時に開けません。残りは 1 件ずつ開いてください。
                    </div>
                    <div style={{ display: "grid", gap: 8 }}>
                        {pendingOrderLaunches.map((item) => (
                            <div key={"pending_order_" + item.index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, border: "1px solid #d9d9d9", borderRadius: 4, padding: "8px 10px" }}>
                                <span style={{ fontSize: 12 }}>{pendingOrderLaunchLabel(item)}</span>
                                <Button size="small" variant="contained" color="primary" onClick={() => openPendingOrderLaunch(item)}>開く</Button>
                            </div>
                        ))}
                    </div>
                    <div style={footerStyle}>
                        <Button size="small" onClick={() => setPendingOrderLaunches([])}>閉じる</Button>
                    </div>
                </Paper>
            </div>
        );
    }


    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                ref={baseref}
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                entrycallback={MenuAction}
                tabs={true}
                navmenu={navmenu.filter(e => e.menuid !== "callform3")}
                entrydataRef={entrydataRef}
                usecondition={true}
                celStyle={celstyle}
                oncellclicked={linkaction}
                OptionChanged={OptionChanged}
                suppressaction={suppressaction }
            >
            </MasterBase>
            {renderPendingOrderLaunchDialog()}
        </div>
    );
};


